import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { siteInfo } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-spy-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-100">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-500">
              {siteInfo.name}悬疑推理追更专区，汇集悬疑、推理、烧脑、反转、案件、解密佳作，剧情反转不断，满足你的推理阅读需求。
            </p>
            <p className="mt-4 text-sm text-foreground-600">
              {siteInfo.email}
            </p>
          </div>

          {/* 分类 */}
          <nav aria-label="作品分类">
            <h3 className="text-sm font-semibold text-foreground-200">
              作品分类
            </h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-accent-300"
                  >
                    {c.name}漫画 · {c.en}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* 快速导航 */}
          <nav aria-label="快速导航">
            <h3 className="text-sm font-semibold text-foreground-200">
              快速导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a href="#updates" className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-accent-300">
                  最新更新
                </a>
              </li>
              <li>
                <a href="#hot" className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-accent-300">
                  热门推荐
                </a>
              </li>
              <li>
                <a href="#topic" className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-accent-300">
                  推理专题
                </a>
              </li>
              <li>
                <Link to="/faq" className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-accent-300">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </nav>

          {/* 追更提示 */}
          <div className="lg:col-span-1">
            <h3 className="text-sm font-semibold text-foreground-200">
              追更小贴士
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-500">
              每周更新多部悬疑推理佳作，连载作品更新后在更新列表置顶标记。收藏你喜欢的作品，第一时间掌握最新章节动态。
            </p>
            <div className="mt-5 flex items-center gap-2 rounded-lg border border-accent-300/30 bg-accent-500/10 px-3 py-2.5 text-xs text-accent-200">
              <i className="ri-flashlight-line" aria-hidden="true"></i>
              烧脑反转 · 高能追更不停歇
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {siteInfo.year} {siteInfo.name} · 悬疑推理漫画在线阅读平台
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供阅读参考，虚构作品请理性看待
          </p>
        </div>
      </div>
    </footer>
  );
}